import { useContext } from 'react';

import { L10nContext } from 'context/L10nContext';

import { ModalDialogueCaptionModifier, ModalDialogueHeader } from 'presentation/ui/compositions/modal-dialogue/modal-dialogue-header/ModalDialogueHeader';
import { ModalDialogueSection } from 'presentation/ui/compositions/modal-dialogue/modal-dialogue-section/ModalDialogueSection';
import { ModalDialogueSectionName } from 'presentation/ui/compositions/modal-dialogue/modal-dialogue-section/ModalDialogueSectionName';
import { ColumnLayoutSection } from 'presentation/ui/layouts/column-layout/column-layout-section/ColumnLayoutSection';
import { ColumnLayoutSectionMode } from 'presentation/ui/layouts/column-layout/column-layout-section/ColumnLayoutSectionMode';
import { ColumnLayout, ColumnLayoutMode } from 'presentation/ui/layouts/column-layout/ColumnLayout';
import { ButtonSecondary, ButtonSecondaryStatus } from 'presentation/ui/partials/button/button-secondary/ButtonSecondary';
import { IconIdentifier } from 'presentation/ui/partials/icon/IconIdentifier';
import { EluateViewModel } from 'services/nuclide/domain/model/EluateModel';

export interface EluateToActiveStateFormProps {
	eluate: EluateViewModel
	onToActiveState: () => void;
	onDismiss: () => void;
}

export const EluateToActiveStateForm = (props: EluateToActiveStateFormProps): JSX.Element => {
	const { eluate, onToActiveState, onDismiss } = props;

	const l10nContext = useContext(L10nContext);

	const extractionDatetimeFormatted = l10nContext.formatDate(eluate.ExtractionDatetime);

	const modalMessage = {
		first: l10nContext.translate('view.eluates.modal.action.toActiveState.message.first', 'Wollen Sie die Eluat-Entnahme vom '),
		last: l10nContext.translate('view.eluates.modal.action.toActiveState.message.last', 'wirklich in den aktiven Status setzen? Die Eluat-Entnahme wird dann wieder unter dem zugehörigen Generator angezeigt und befindet sich nicht mehr im Abfall-Modul')
	};

	return (
		<>
			<ModalDialogueHeader
				captionText={l10nContext.translate('common.modal.captionAttention', 'Achtung')}
				captionIcon={IconIdentifier.ALERT}
				captionModifier={ModalDialogueCaptionModifier.SMALL_CAPTION}
			/>
			<ModalDialogueSection>
				<>
					{modalMessage.first} <b>{extractionDatetimeFormatted}</b> {modalMessage.last}
				</>
			</ModalDialogueSection>

			<ModalDialogueSection section={ModalDialogueSectionName.SECTION_FOOTER}>
				<ColumnLayout mode={ColumnLayoutMode.ALIGN_RIGHT}>
					<ColumnLayoutSection mode={ColumnLayoutSectionMode.MODE_FIXED}>
						<ButtonSecondary
							buttonText={l10nContext.translate('common.button.abort', 'Abbrechen')}
							onClick={onDismiss}
						/>
					</ColumnLayoutSection>
					<ColumnLayoutSection mode={ColumnLayoutSectionMode.MODE_FIXED}>
						<ButtonSecondary
							buttonText={l10nContext.translate('view.eluates.modal.action.toActiveState.setActiveConfirm', 'Ja, in den aktiven Status setzen')}
							status={ButtonSecondaryStatus.ATTENTION}
							icon={IconIdentifier.TRASH}
							onClick={onToActiveState}
						/>
					</ColumnLayoutSection>
				</ColumnLayout>
			</ModalDialogueSection>
		</>
	);
};
